module.exports = __webpack_public_path__ + "img/12_003.498c104f.webp";